<button mat-icon-button [matMenuTriggerFor]="menu" class="example-icon" aria-label="Identy titlebar">
  <mat-icon>menu</mat-icon>
</button>

<mat-menu #menu="matMenu" xPosition="before" >
  <div (click)="$event.stopPropagation()">
  <menu-options-component
    [options]="menu_options"
    (valueChange)="onValueChange($event)">
  </menu-options-component>
  </div>

  <div class="versions-region">
    <div style="font-size: 12px;margin-top: 5px">Client Version: {{ client_version }}</div>
    <div style="font-size: 12px">Server Version: {{ server_version }}</div>
  </div>
</mat-menu>
